<template>
  <v-app>
    <Drawer :drawer="drawer" />
    <v-app-bar app color="baseColor" dark dense clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>{{ rhrCoreShellOptions.name }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <component :is="rhrCoreShellOptions.appBarAfterSpacer"></component>
    </v-app-bar>
    <v-content>
      <v-container grid-list-lg class="mb-5 pa-3" fluid>
        <slot></slot>
      </v-container>
    </v-content>
    <v-navigation-drawer
      v-model="rightDrawer"
      width="350"
      fixed
      right
      temporary
    >
    </v-navigation-drawer>
    <v-footer elevation="10" app absolute inset padless>
      <base-layout-footer></base-layout-footer>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import Drawer from "../components/Drawer";

import BaseLayoutFooter from "../components/Common/LayoutUtils/Footer";

export default {
  components: {
    Drawer,
    BaseLayoutFooter
  },
  data() {
    return {
      rhrCoreShellOptions: {},
      drawer: true,
      rightDrawer: false
    };
  },
  computed: {
    ...mapGetters({})
  },
  async created() {},
  mounted() {
    this.rhrCoreShellOptions = window.rhrCoreShellOptions;
  },
  methods: {
    ...mapMutations({}),
    ...mapActions({}),
    async switchOrganization() {}
  }
};
</script>
